import { useQuery } from '@tanstack/react-query'
import { lcCoachingApi } from '@/api/lcCoaching'
import { coachingKeys } from './useCoachingToday'

export function useTodayClasses() {
  return useQuery({
    queryKey: coachingKeys.classes(),
    queryFn: () => lcCoachingApi.getTodayClasses(),
    staleTime: 30_000,
  })
}
